import { render, staticRenderFns } from "./WaveProDetails.vue?vue&type=template&id=09a1cbf8&"
import script from "./WaveProDetails.vue?vue&type=script&lang=js&"
export * from "./WaveProDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports